import { render } from "./OliverAvatar.vue?vue&type=template&id=3c50fa64&scoped=true"
import script from "./OliverAvatar.vue?vue&type=script&lang=js"
export * from "./OliverAvatar.vue?vue&type=script&lang=js"

import "./OliverAvatar.vue?vue&type=style&index=0&id=3c50fa64&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c50fa64"]])

export default __exports__